import React, { useState, useEffect } from 'react';
import services from '../services';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import CSVReader from 'react-csv-reader';
import { cardUploadSchemaObject } from '../validations';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

const screenCode = 'CARDUPLOAD'

export function CardUploadAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Card Upload");
    const [buttonName, setButtonName] = useState("Upload")
    const [groups, setGroups] = useState([]);
    const [isChanged, setIsChanged] = useState(0);
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoints, setCollectionPoints] = useState()
    const [collectionCategory, setCollectionCategory] = useState();
    const [cardUpload, setCardUpload] = useState({
        groupID: '0',
        operationEntityTypeID: '0',
        operationEntityID: '0',
        collectionCatagoryID: '0',
        collectionPointID: '0',
        customers: []
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isFileChosen, setIsFileChosen] = useState(false);
    const [fileInfo, setFileInfo] = useState({});

    const schema = Joi.object(cardUploadSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [cardUpload.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
    }, [cardUpload.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointDropDownItems()
        )
    }, [cardUpload.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'CARDUPLOAD');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setCardUpload({
            ...cardUpload,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupDropdownData()
        )
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(cardUpload.operationEntityID);
        setCollectionCategory(collectionCategories);
    }

    async function getGroupDropdownData() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntities() {
        const operationEntity = await services.getAllOperationEntitiesForDropDown(cardUpload.groupID);
        setOperationEntity(operationEntity);

    }

    async function getCollectionPointDropDownItems() {
        const collectionPoint = await services.GetCollectionPoints(cardUpload.operationEntityID);
        setCollectionPoints(collectionPoint);
    }

    async function handleSave(e) {
        e.preventDefault();

        var customerDetails = {
            customers: cardUpload.customers,
            groupID: parseInt(cardUpload.groupID),
            operationEntityID: parseInt(cardUpload.operationEntityID),
            collectionCatagoryID: parseInt(cardUpload.collectionCatagoryID),
            collectionPointID: parseInt(cardUpload.collectionPointID)
        }
      
        const response = await services.saveCardUpload(customerDetails);
        setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message});

        if(response.statusCode == 'Success'){
            clearState();
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
    }

    function handleChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, cardUploadSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setCardUpload({
            ...cardUpload,
            [e.target.name]: value
        });

        setErrors(error);
    }

    const handleForce = (data, fileInfo) => {
        setIsFileChosen(true);
        setFileInfo(fileInfo);
        setCardUpload({
            ...cardUpload,
            customers: data
        })
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setCardUpload({
            ...cardUpload,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCatagoryID: '0',
            collectionPointID: '0',
            customers: []
        });

        setIsFileChosen(false);
        setFileInfo({});
    }

    const papaparseOptions = {
        header: true,
        dynamicTyping: false,
        quoteChar: '"',
        skipEmptyLines: true,
        parseNumbers: true,
        transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '')
    };

    return (
        <div>
            <LoadingSpinerComponent />

            <div className="card">
                <PageHeader
                    title={title}
                    isButtonEnable={false}
                />

                <div className="card-body">
                    <div className="row row-top-gap">
                        <div className="col-md-4 pb-1">
                            <TextField select fullWidth
                                label="Group *"
                                id="groupID"
                                disabled={!permissionList.isGroupFilterEnabled}
                                name="groupID"
                                value={cardUpload.groupID}
                                onChange={(e) => handleChange(e)}>
                                <option value="0">--Select Group--</option>
                                {generateDropDownMenu(groups)}
                            </TextField>
                            {errors["groupID"] && <span id="errbranchCode" className="text text-danger">{errors["groupID"]}</span>}
                        </div>
                        <div className="col-md-4 pb-1">
                            <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                            <Select fullWidth
                                label="Operation Entity *"
                                id="operationEntityID"
                                disabled={!permissionList.isOperationEntityFilterEnabled}
                                name="operationEntityID"
                                value={cardUpload.operationEntityID}
                                onChange={(e) => handleChange(e)}>
                                <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                {generateDropDownMenu(operationEntity)}
                            </Select>
                            {errors["operationEntityID"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</span>}
                        </div>
                        <div className="col-md-4 pb-1">
                            <TextField select fullWidth
                                label="Collection Point *"
                                id="collectionPointID"
                                name="collectionPointID"
                                value={cardUpload.collectionPointID}
                                onChange={(e) => handleChange(e)}>
                                <option value="0">--Select Collection Point--</option>
                                {generateDropDownMenu(collectionPoints)}
                            </TextField>
                            {errors["collectionPointID"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</span>}
                        </div>
                        <div className="col-md-4 pb-1">
                            <TextField select fullWidth
                                label="Collection Category *"
                                id="collectionCatagoryID"
                                name="collectionCatagoryID"
                                value={cardUpload.collectionCatagoryID}
                                onChange={(e) => handleChange(e)}>
                                <option value="0">--Select Collection Catagory--</option>
                                {generateDropDownMenu(collectionCategory)}
                            </TextField>
                            {errors["collectionCatagoryID"] && <span id="errbranchCode" className="text text-danger">{errors["collectionCatagoryID"]}</span>}
                        </div>

                    </div>
                    <div className="col-md-4 pb-1">
                        <button className="btn" style={{ marginTop: 20, marginRight: 10, backgroundColor: '#28a761', color: '#fff !important'}}>
                            <CSVReader
                                label={isFileChosen ? 'File Chosen' : 'Choose File'}
                                onFileLoaded={handleForce}
                                parserOptions={papaparseOptions}
                                inputId="react-csv-reader-input"
                                cssClass="csv-reader-input"
                            />
                        </button>
                        {isFileChosen ? <span>{fileInfo.name}</span> : null}
                    </div>
                </div>

                <div className="card-footer">

                    <input
                        disabled={validate(schema, cardUpload)}
                        type="submit"
                        className="btn btn-primary"
                        onClick={(e) => trackPromise(handleSave(e))}
                        value={buttonName}
                    />

                    <input 
                        type="reset" 
                        className="btn btn-warning pull-right"
                        value="Clear"
                        onClick={clearState}
                    />
                </div>
                <MessageModal
                    hidden={messageModel.hidden}
                    messageType={messageModel.type}
                    messageDescription={messageModel.disciption}
                    clicked={modalDismissHandler}
                />
            </div>
        </div>
    );
}